




































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import axios from "axios";
import { ssmTokenService } from "@/shared/services/token-service";
import DxButton from "devextreme-vue/button";

@Component({
  components: {
    DxButton,
  },
})
export default class excel_import_file extends Vue {
  public archivo: File | null = null;
  public mensaje: string = "";

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) {
      console.error("No se ha seleccionado ningún archivo.");
      return;
    }
    const file = target.files[0];
    const extension = file.name.split(".").pop()!.toLowerCase();
    if (extension === "xlsx") {
      this.archivo = file;
    } else {
      alert("Por favor, selecciona un archivo Excel válido.");
    }
  }

  enviarArchivo() {
    if (!this.archivo) {
      alert("No has seleccionado un archivo.");
      return;
    }
    this.mensaje = "";

    const formData = new FormData();
    formData.append("file", this.archivo);

    axios
      .post(API.kml + "/importar-excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + ssmTokenService.getToken(),
        },
      })
      .then((response) => {
        alert("Archivo subido con éxito");
      })
      .catch((error) => {
        console.error("Error al subir el archivo:", error);
        this.mensaje = "Error al subir el archivo.";
        if (
          error &&
          error.toString &&
          error.toString().includes("Request failed with status code 500")
        ) {
          this.mensaje += " Comprueba el formato del documento.";
        }
      });
  }
}
